<template>
  <b-modal
    v-model="isVisible"
    hide-footer
    size="lg"
  >
    <b-card>
      <h3 class="text-center">Información de la Imagen Programada</h3>
      <hr>

      <div v-if="imagen">
        <div>
          <i class="fas fa-user" style="margin-right: 10px;"/>
          <b>Paciente:</b> {{ imagen.paciente.identificacion }} - {{ imagen.paciente.nombres }}
        </div>

        <div>
          <i class="fas fa-phone" style="margin-right: 10px;"/>
          <b>Teléfono - correo:</b> {{ imagen.paciente.telefono }} - {{ imagen.paciente.correo }}
        </div>
      
        <hr>

        <div>
          <i class="fas fa-user" style="margin-right: 10px;"/>
          <b>Doctor:</b> {{ imagen.doctor.nombres }} - {{ imagen.doctor.especialidad }}
        </div>

        <hr>

        <div>
          <i class="fas fa-arrow-right" style="margin-right: 10px;"/>
          <b>Estado:</b> {{ imagen.estadoImagen }}
        </div>

        <div>
          <i class="fas fa-arrow-right" style="margin-right: 10px;"/>
          <b>Fecha de Emisión:</b> {{ imagen.fechaCreacion }}
        </div>

        <div>
          <i class="fas fa-arrow-right" style="margin-right: 10px;"/>
          <b>Fecha de Programada:</b> {{ imagen.fechaProgramada }}
        </div>

        <hr>
        <div>
          <i class="fas fa-arrow-right" style="margin-right: 10px;"/>
          <b>Número de Order As400 :</b> {{ imagen.numeroOrdenAs400 }}
        </div>
        
        <div>
          <i class="fas fa-arrow-right" style="margin-right: 10px;"/>
          <b>Imagen:</b> {{ imagen.imagen }}
        </div>

        <div>
          <i class="fas fa-arrow-right" style="margin-right: 10px;"/>
          <b>Lateralidad:</b> {{ imagen.lateralidad }}
        </div>

        <div>
          <i class="fas fa-arrow-right" style="margin-right: 10px;"/>
          <b>Motivo de Solicitud:</b> {{ imagen.motivoSolicitud }}
        </div>

        <div>
          <i class="fas fa-arrow-right" style="margin-right: 10px;"/>
          <b>Resumen Clínico:</b> {{ imagen.resumenClinico }}
        </div>

        <div>
          <i class="fas fa-arrow-right" style="margin-right: 10px;"/>
          <b>Justificación:</b> {{ imagen.justificacion }}
        </div>

        <div>
          <i class="fas fa-arrow-right" style="margin-right: 10px;"/>
          <b>Sedación:</b> {{ imagen.sedacion }}
        </div>

        <hr>

        <div>
          <i class="fas fa-arrow-right" style="margin-right: 10px;"/>
          <b>Imagenólogo:</b> {{ imagen.imaginologo }}
        </div>

        <div>
          <i class="fas fa-arrow-right" style="margin-right: 10px;"/>
          <b>Informe de Imagen:</b> {{ imagen.informeImagen }}
        </div>

        <div>
          <i class="fas fa-arrow-right" style="margin-right: 10px;"/>
          <b>Conclusión de Imagen:</b> {{ imagen.conclusionImagen }}
        </div>

        <div>
          <i class="fas fa-arrow-right" style="margin-right: 10px;"/>
          <b>Archivo Informe:</b> 
          <!-- {{ imagen.urlInforme }} -->
          <small v-if="!imagen.urlInforme" class="ml-1 text-warning">No hay archivo</small>
          <b-link
            v-if="imagen.urlInforme"
            @click="onViewFile(imagen.urlInforme)" 
            class="text-primary ml-1" 
            style="cursor: pointer;"
          >
            <small id="v-name">Ver Archivo</small>
          </b-link>
        </div>

        <div>
          <i class="fas fa-arrow-right" style="margin-right: 10px;"/>
          <b>Carpeta Imágenes:</b> 
          <!-- {{ imagen.urlCarpetaImagenes }} -->
          <small v-if="!imagen.urlCarpetaImagenes" class="ml-1 text-warning">No hay archivo</small>
          <b-link 
            v-if="imagen.urlCarpetaImagenes"
            @click="onViewFile(imagen.urlCarpetaImagenes)" 
            class="text-primary ml-1" 
            style="cursor: pointer;"
          >
            <small id="v-name">Ver Archivo</small>
          </b-link>
        </div>

        <div>
          <i class="fas fa-arrow-right" style="margin-right: 10px;"/>
          <b>Visor Imágenes Dicom:</b> 
          <small v-if="!imagen.urlCarpetaImagenesDicom" class="ml-1 text-warning">No hay archivo</small>
          <b-link 
            v-if="imagen.urlCarpetaImagenesDicom"
            @click="onViewDicomEditor(imagen.urlCarpetaImagenesDicom)" 
            class="text-primary ml-1" 
            style="cursor: pointer;"
          >
            <small id="v-name">Editar con Viewer</small>
          </b-link>
        </div>
        <div>
          <i class="fas fa-arrow-right" style="margin-right: 10px;" />
          <b>Comentarios imagen:</b>
          <small v-if="!imagen.urlDicomModificado" class="ml-1 text-warning">No hay archivo</small>

          <b-link
            v-if="imagen.urlDicomModificado"
            @click="onViewFile(imagen.urlDicomModificado)"
            class="text-primary ml-1"
            style="cursor: pointer;"
          >
            <small>Ver archivo</small>
          </b-link>
        </div>
        <hr> 
        <div class="row">
          <div class="col-md-6">
            <div>
              <i class="fas fa-arrow-right" style="margin-right: 10px;"/>
              <b>MSP Paciente:</b> 
              <!-- {{ imagen.urlCarpetaImagenes }} -->
              <small v-if="!imagen.urlMsp" class="ml-1 text-warning">No hay archivo</small>
              <b-link 
                v-if="imagen.urlMsp"
                @click="onViewFile(imagen.urlMsp)" 
                class="text-primary ml-1" 
                style="cursor: pointer;"
              >
                <small id="v-name">Ver Archivo</small>
              </b-link>
            </div>
            <div v-if="imagen.urlMspTitular1">
              <i class="fas fa-arrow-right" style="margin-right: 10px;"/>
              <b>MSP Titular 1:</b> 
              <!-- {{ imagen.urlCarpetaImagenes }} -->
              <small v-if="!imagen.urlMspTitular1" class="ml-1 text-warning">No hay archivo</small>
              <b-link 
                v-if="imagen.urlMspTitular1"
                @click="onViewFile(imagen.urlMspTitular1)" 
                class="text-primary ml-1" 
                style="cursor: pointer;"
              >
                <small id="v-name">Ver Archivo</small>
              </b-link>
            </div>

            <div v-if="imagen.urlMspTitular2">
              <i class="fas fa-arrow-right" style="margin-right: 10px;"/>
              <b>MSP Titular 2:</b> 
              <!-- {{ imagen.urlCarpetaImagenes }} -->
              <small v-if="!imagen.urlMspTitular2" class="ml-1 text-warning">No hay archivo</small>
              <b-link 
                v-if="imagen.urlMspTitular2"
                @click="onViewFile(imagen.urlMspTitular2)" 
                class="text-primary ml-1" 
                style="cursor: pointer;"
              >
                <small id="v-name">Ver Archivo</small>
              </b-link>
            </div>

            <div v-if="imagen.urlMspTitular3">
              <i class="fas fa-arrow-right" style="margin-right: 10px;"/>
              <b>MSP Titular 3:</b> 
              <!-- {{ imagen.urlCarpetaImagenes }} -->
              <small v-if="!imagen.urlMspTitular3" class="ml-1 text-warning">No hay archivo</small>
              <b-link 
                v-if="imagen.urlMspTitular3"
                @click="onViewFile(imagen.urlMspTitular3)" 
                class="text-primary ml-1" 
                style="cursor: pointer;"
              >
                <small id="v-name">Ver Archivo</small>
              </b-link>
            </div>
          </div>

          <!-- archivos msp dia 2 -->
          <div
            v-if="imagen.urlMspDay2 || imagen.urlMspTitular1Day2 || imagen.urlMspTitular2Day2 || imagen.urlMspTitular3Day2"
            class="col-md-6"
          >
            <div>
              <i class="fas fa-arrow-right" style="margin-right: 10px;"/>
              <b>MSP Paciente:</b> 
              <!-- {{ imagen.urlCarpetaImagenes }} -->
              <small v-if="!imagen.urlMspDay2" class="ml-1 text-warning">No hay archivo</small>
              <b-link 
                v-if="imagen.urlMspDay2"
                @click="onViewFile(imagen.urlMspDay2)" 
                class="text-primary ml-1" 
                style="cursor: pointer;"
              >
                <small id="v-name">Ver Archivo</small>
              </b-link>
            </div>

            <div v-if="imagen.urlMspTitular1Day2">
              <i class="fas fa-arrow-right" style="margin-right: 10px;"/>
              <b>MSP Titular 1:</b> 
              <!-- {{ imagen.urlCarpetaImagenes }} -->
              <small v-if="!imagen.urlMspTitular1Day2" class="ml-1 text-warning">No hay archivo</small>
              <b-link 
                v-if="imagen.urlMspTitular1Day2"
                @click="onViewFile(imagen.urlMspTitular1Day2)" 
                class="text-primary ml-1" 
                style="cursor: pointer;"
              >
                <small id="v-name">Ver Archivo</small>
              </b-link>
            </div>

            <div v-if="imagen.urlMspTitular2Day2">
              <i class="fas fa-arrow-right" style="margin-right: 10px;"/>
              <b>MSP Titular 2:</b> 
              <!-- {{ imagen.urlCarpetaImagenes }} -->
              <small v-if="!imagen.urlMspTitular2Day2" class="ml-1 text-warning">No hay archivo</small>
              <b-link 
                v-if="imagen.urlMspTitular2Day2"
                @click="onViewFile(imagen.urlMspTitular2Day2)" 
                class="text-primary ml-1" 
                style="cursor: pointer;"
              >
                <small id="v-name">Ver Archivo</small>
              </b-link>
            </div>

            <div v-if="imagen.urlMspTitular3Day2">
              <i class="fas fa-arrow-right" style="margin-right: 10px;"/>
              <b>MSP Titular 3:</b> 
              <!-- {{ imagen.urlCarpetaImagenes }} -->
              <small v-if="!imagen.urlMspTitular3Day2" class="ml-1 text-warning">No hay archivo</small>
              <b-link 
                v-if="imagen.urlMspTitular3Day2"
                @click="onViewFile(imagen.urlMspTitular3Day2)" 
                class="text-primary ml-1" 
                style="cursor: pointer;"
              >
                <small id="v-name">Ver Archivo</small>
              </b-link>
            </div>
          </div>
        </div>
        

        <hr>

        <div>
          <h6>Informes:</h6>

          <div v-if="imagen.estadoImagen === 'Terminada'">
            <i class="fas fa-arrow-right" style="margin-right: 10px;"/>
            <b>12B:</b>

            <b-button
              class="ml-1"
              size="sm"
              @click="onViewFile12b(tokenImagen)"
              :disabled="load12b"
            >
              <i class="fa-solid fa-file"/>
            </b-button>

          </div>
        </div>
        
      </div>

    </b-card>

    <ModalViewFile
      v-if="fileToView"
      :urlFile="fileToView"
      v-model="isModalFileVisible"
    />

    <ModalViewFile
      v-if="modalFile.fileToView"
      :urlFile="modalFile.fileToView"
      :rutaCompleta="modalFile.isRutaCompleta"
      v-model="modalFile.isVisible"
    />
  </b-modal>
  
</template>

<script>
import { stringDateToGeneralDate } from '@/shared/helpers';
import { ModalViewFile } from '@/shared/components';
import { imagenesService } from '../../services';
import rutas from '@/assets/utils/rutas.json';
export default {
  name: "VerImagenProgramada",

  components: {
    ModalViewFile
  },

  data() {
    return {
      tokenImagen: null,
      imagen: null,
      isVisible: false,
      fileToView: null,
      isModalFileVisible: false,
      modalFile: {
        fileToView: null,
        isVisible: false,
        isRutaCompleta: false
      },
      load12b: false
    };
  },

  mounted() {
    this.onGetDataView();
  },

  methods: {
    async onGetDataView() {
      const urlParams = new URLSearchParams(window.location.search);
      const tokenImagen = urlParams.get("view_imagen");

      if (!tokenImagen) return;

      this.tokenImagen = tokenImagen;
      const data = await imagenesService.getByToken(tokenImagen);

      if (!data) {
        await this.$swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo obtener la información de la imagen programada'
        });
        this.$router.push({ path: this.$route.path, query: {} });
        return;
      }

      const dataInforme = data.informes?.length ? data.informes[0] : null;
      localStorage.setItem("idInforme", dataInforme?.id);
      // 👇 guarda el id para usarlo en el componente que ejecuta la mutación
      localStorage.setItem("envio_imagen_id", String(data.id));
      const dataImaginologo = dataInforme?.imagenologo
        ? `${dataInforme?.imagenologo?.idPersona.primerApellido} ${dataInforme?.imagenologo?.idPersona.primerNombre}`
        : '';

      const dataPaciente = data.consultamedica.cita.paciente.persona;
      const paciente = {
        identificacion: dataPaciente.identificacion,
        nombres: `${dataPaciente.primerApellido} ${dataPaciente.primerNombre}`,
        telefono: dataPaciente.telefono,
        correo: dataPaciente.correo
      };

      const dataDoctor = data.consultamedica.cita.doctor;
      const doctor = {
        nombres: `${dataDoctor.idPersona.primerApellido} ${dataDoctor.idPersona.primerNombre}`,
        especialidad: dataDoctor.especialidad.descripcion
      };

      const dataFechaCreacion = stringDateToGeneralDate(data.fechaCreacion);
      const fechaCreacion = `${dataFechaCreacion.date} ${dataFechaCreacion.time}`;

      const dataFechaProgramada = stringDateToGeneralDate(data.fechaProgramada);
      const fechaProgramada = data.fechaProgramada
        ? `${dataFechaProgramada.date} ${dataFechaProgramada.time}`
        : '';

      const urlMsp = this.getUrlMsp(dataInforme?.urlMsp, 1);
      const urlMspDay2 = this.getUrlMsp(dataInforme?.urlMsp, 2);

      const urlMspTitular1 = this.getUrlMsp(dataInforme?.urlMspTitular1, 1);
      const urlMspTitular1Day2 = this.getUrlMsp(dataInforme?.urlMspTitular1, 2);

      const urlMspTitular2 = this.getUrlMsp(dataInforme?.urlMspTitular2, 1);
      const urlMspTitular2Day2 = this.getUrlMsp(dataInforme?.urlMspTitular2, 2);

      const urlMspTitular3 = this.getUrlMsp(dataInforme?.urlMspTitular3, 1);
      const urlMspTitular3Day2 = this.getUrlMsp(dataInforme?.urlMspTitular3, 2);

      const imagenMapper = {
        id: data.id,
        token: data.token,
        imagen: `${data.imagen.codigo} - ${data.imagen.nombre}`,
        lateralidad: data.lateralidad?.nombre,
        numeroOrdenAs400: data.numeroOrdenAs400,
        motivoSolicitud: data.motivoSolicitud,
        resumenClinico: data.resumenClinico,
        justificacion: data.justificacion || 'NO APLICA',
        sedacion: data.sedacion === '1' ? 'SI' : 'NO',
        estadoImagen: data.estadoImagen,
        fechaCreacion: fechaCreacion,
        fechaProgramada: fechaProgramada,
        imaginologo: dataImaginologo,
        conclusionImagen: dataInforme?.conclusionImagen || '',
        informeImagen: dataInforme?.informeImagen || '',
        urlInforme: dataInforme?.urlInforme || '',
        urlCarpetaImagenes: dataInforme?.urlCarpetaImagenes || '',
        urlCarpetaImagenesDicom: dataInforme?.urlCarpetaImagenesDicom || '',
        urlDicomModificado: dataInforme?.urlDicomModificado || '',
        urlMsp: urlMsp || '',
        urlMspDay2: urlMspDay2 || '',
        urlMspTitular1: urlMspTitular1 || '',
        urlMspTitular1Day2: urlMspTitular1Day2 || '',
        urlMspTitular2: urlMspTitular2 || '',
        urlMspTitular2Day2: urlMspTitular2Day2 || '',
        urlMspTitular3: urlMspTitular3 || '',
        urlMspTitular3Day2: urlMspTitular3Day2 || '',
        paciente,
        doctor
      };

      this.imagen = imagenMapper;
      this.isVisible = true;
    },

    getUrlMsp(dataMsp, day) {
      let urlMsp = null;
      try {
        const objectParsed = JSON.parse(dataMsp);
        urlMsp = objectParsed.urls[day];
      } catch (error) {
        if (day === 2) return null;
        urlMsp = dataMsp;
      }
      return urlMsp;
    },

    async onViewFile12b(tokenImagen) {
      this.load12b = true;
      const urlTemp = await imagenesService.getUrlView12b(tokenImagen);

      if (!urlTemp) {
        this.load12b = false;
        this.$swal({
          title: 'Error',
          text: "El archivo no existe",
          icon: 'error',
        });
        return;
      }

      this.modalFile.isRutaCompleta = true;
      this.modalFile.fileToView = urlTemp;
      this.modalFile.isVisible = true;
      this.load12b = false;
    },

    onViewFile(url) {
      this.fileToView = url;
      this.isModalFileVisible = true;
    },

    onViewDicomPreview(url) {
      this.fileToView = `/ver-dicom/${this.tokenImagen}/`; // Adjust based on your endpoint
      this.isModalFileVisible = true;
    },

    onViewDicomEditor() {
      const routeData = this.$router.resolve({
        name: 'dicom_viewer',
        params: { token: this.tokenImagen }
      });
      console.log(routeData.href);
      window.open(routeData.href, '_blank'); // nueva pestaña
      // o this.$router.push(routeData.location) si lo quieres en la misma SPA
    }
  },

  watch: {
    '$route.query.view_imagen': {
      handler() {
        this.onGetDataView();
      }
    },

    isVisible: {
      deep: true,
      handler(newValue) {
        if (!newValue) {
          const updatedQuery = { ...this.$route.query };
          delete updatedQuery.view_imagen;
          this.$router.push({ path: this.$route.path, query: updatedQuery });
        }
      }
    }
  },
};
</script>